// extracted by mini-css-extract-plugin
module.exports = {"minPriceContainer":"min_price_panel_minPriceContainer__3v2jz","minPriceContent":"min_price_panel_minPriceContent__17G6I","minPrice":"min_price_panel_minPrice__WmYWF"};